import {Component} from '@angular/core';
import {SidebarComponent} from '../../sidebar/sidebar.component';
import {PanelComponent} from '../../panel/panel.component';

@Component({
  selector: 'app-settings',
  imports: [
    SidebarComponent,
    PanelComponent
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.css',
})
export class SettingsComponent {

}
